export default {
  PROFILEOBJ: 'PROFILEOBJ',
  HISTORYOBJ: 'HISTORYOBJ',
  AUTHORIZATION: 'AUTHORIZATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  OPENTOOLSMODAL: 'OPENTOOLSMODAL',
  OPENLEAVE: 'OPENLEAVE',
  ALLSUBSCRIPTION: 'ALLSUBSCRIPTION',
  OPENPACK: 'OPENPACK',
};
